module.exports = "/static/media/live-receptionist.587a8bdd.png";